import { render, staticRenderFns } from "./practitioners-list.vue?vue&type=template&id=f2e805d4&"
import script from "./practitioners-list.vue?vue&type=script&lang=ts&"
export * from "./practitioners-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports